<template>
  <div id="scrolltop" v-bind:class="['my-4 ma-md-5 mx-lg-10 mx-xl-10', {
    'px-4': !$vuetify.breakpoint.mdAndUp,
  }]">
    <div :class="locked ? 'calendarFixedLocked' : 'calendarFixed'">
      <div class="titleAndMap">
        <h2 class="titleH2"> {{ $t('views.pulsoDigital.title') }}</h2>
        <v-col
          class="mx-3"
          :style="{
            width: 'fit-content',
            padding: '0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexGrow: '0 !important'
        }">
          <div
            :class="{'text-right':true, 'showMobile':true,
            'chip__active': showMobile, 'activeBtnSearchMobile': showMobile}"
            :style="{width: 'fit-content'}"
            >
              <v-btn
                class="showSearchBtn"
                icon
                @click="showSearch()"
              >
                <v-icon size="37">icon-ayudadigital-lupa</v-icon>
              </v-btn>
            </div>
          <div
            class="text-right"
            :style="{width: 'fit-content'}">
            <v-btn
              icon
              title="Ver mapa"
              id="no-background-hover"
              @click="navigateToMap"
            >
              <v-icon size="40">icon-ayudadigital-chincheta</v-icon>
            </v-btn>
          </div>
          <div
            v-if="isUserTic && !onlyAccessPulso"
            :class="{'text-right':true, 'showMobile':true}"
            :style="{width: 'fit-content'}"
            >
              <v-btn
                class="showSearchBtn"
                icon
                to="/pulsodigital/incidenciasproactivas"
              >
                <v-icon size="41">icon-ayudadigital-incidencias-relleno</v-icon>
              </v-btn>
            </div>
        </v-col>
      </div>
      <p class="showWeb" :style="{margin: '1rem 0'}" v-html="$t('views.pulsoDigital.description')"/>
      <!-- INICIO BUSCADOR WEB -->
      <v-row v-if="!showMobile" :class="{ 'd-flex mx-1 mb-1': true,
        'searchMobile':showMobile, 'searchMobileHide': !showMobile
        }"
        :style="{
          marginLeft: '1px !important',
        }"
      >
        <v-col class="flex-grow-1">
          <SearchField
            class="white mb-2"
            :disabled="data.loading"
            v-bind="properties"
            :prependIcon="true"/>
        </v-col>
      </v-row>

      <!-- INICIO BUSCADOR APP-->
      <v-row v-if="showMobile" :class="{ 'd-flex mx-1 mb-1': true,
        'searchMobile':showMobile, 'searchMobileHide': !showMobile
        }"
        :style="{
          marginLeft: '1px !important',
        }"
      >
        <v-col class="flex-grow-1">
          <SearchField
            class="white mb-2"
            :disabled="data.loading"
            v-bind="properties"/>
        </v-col>
        <v-col
          class="mx-3"
          :style="{
            width: 'fit-content',
            padding: '0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexGrow: '0 !important'
          }"
        >
          <div
            class="text-right showWeb"
            :style="{width: 'fit-content'}"
          >
            <v-btn
              icon
              title="Ver mapa"
              id="no-background-hover"
              to="/pulsodigital/map"
            >
              <v-icon size="40">icon-ayudadigital-chincheta</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>

      <!-- INICIO LEYENDA -->
      <v-card
        class="leyenda_box"
        color="white">
        <v-col
          :style="{ padding: '0.3rem 0 !important'}">
          <v-row class="myRequestScroll" :style="{gap: '0.5rem', margin: '0.5rem 0 !important'}">
            {{ /* FILTRO NUEVO PULSO */ }}
            <v-slide-group
              multiple
              show-arrows
            >
              <v-slide-item :disabled="data.loading">
                <div class="container__chip">
                  <span :class="'chip__agrupaciones chip__filter v-chip'">
                    <div class="chipMenu">
                      <v-menu >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            density="compact"
                            variant="text"
                            v-on="on"
                            class="btn__filter"
                            :ripple="false"
                            @click="()=>{menuFlags[0] = !menuFlags[0]}"
                          >
                            <span>
                              <b>Tipo:</b> {{ findTypeName() }}
                            </span>
                            <v-icon class="iconChips">
                            {{
                              !menuFlags[0] ?
                                'mdi-chevron-up' :
                                'mdi-chevron-down'
                            }}
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list class="listSheet">
                          <template
                            v-for="(item, index) in typeFilter"
                            >
                            <v-list-item
                            link
                            class="listSheetItem"
                            :key="index + item.value"
                            >
                              <v-list-item-title
                                class="listSheetTitle"
                                @click="handleTypeFilter(item)"
                              >
                                <v-icon size="16" class="iconChips iconChipSize">
                                  {{
                                    item.active ?
                                      'mdi-check-bold' :
                                      ''
                                  }}
                                </v-icon>
                                <v-badge
                                  v-if="item.color"
                                  class="d-inline"
                                  inline
                                  :color="item.color ? item.color : ''"
                                  dot
                                ></v-badge>
                                {{ item.label }}
                              </v-list-item-title>
                            </v-list-item>
                            <v-divider
                              v-if="index < typeFilter.length - 1"
                              :key="index * 2"
                            />
                          </template>
                        </v-list>
                      </v-menu>
                    </div>
                </span>
              </div>
              </v-slide-item>
                            <v-slide-item :disabled="data.loading">
                <div class="container__chip">
                  <span :class="'chip__agrupaciones chip__filter v-chip'">
                    <div class="chipMenu">
                      <v-menu >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            density="compact"
                            variant="text"
                            v-on="on"
                            class="btn__filter"
                            :ripple="false"
                            @click="()=>{menuFlags[2] = !menuFlags[2]}"
                          >
                            <span>
                              <b>Ámbito:</b> {{ findScopeName() }}
                            </span>
                            <v-icon class="iconChips">
                            {{
                              !menuFlags[2] ?
                                'mdi-chevron-up' :
                                'mdi-chevron-down'
                            }}
                          </v-icon>
                        </v-btn>
                        <!-- CONDICIONAR EL FILTRO TODOS PARA NO MOSTRAR EL MENU -->
                        </template>
                        <v-list class="listSheet">
                          <template
                            v-for="(item, index) in ambitoFilter"
                            >
                            <v-list-item
                            link
                            class="listSheetItem"
                            :key="index + 12 * 19 + item.value"
                            :disabled="item.inmutable"
                            >
                              <v-list-item-title class="listSheetTitle"
                              @click="handleAmbitoFilter(item)">
                                <v-icon size="16" class="iconChips iconChipSize">
                                  {{
                                    item.active ?
                                    'mdi-check-bold' : ''
                                  }}
                                </v-icon>
                                <v-badge
                                  v-if="item.color"
                                  class="d-inline"
                                  inline
                                  :color="item.color ? item.color : ''"
                                  dot
                                ></v-badge>
                                {{ item.label }}
                              </v-list-item-title>
                            </v-list-item>
                            <v-divider
                              v-if="index < typeFilter.length - 1"
                              :key="index * 100 + item.value"
                            />
                          </template>
                        </v-list>
                      </v-menu>
                    </div>
                  </span>
                </div>
              </v-slide-item>
              <v-slide-item :disabled="data.loading">
                <div class="container__chip">
                  <span :class="'chip__agrupaciones chip__filter v-chip'">
                    <div class="chipMenu">
                      <v-menu >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            density="compact"
                            variant="text"
                            v-on="on"
                            class="btn__filter"
                            :ripple="false"
                            @click="()=>{menuFlags[1] = !menuFlags[1]}"
                          >
                            <span>
                              <b>Estados:</b> {{ findStatusName() }}
                            </span>
                            <v-icon class="iconChips">
                            {{
                              !menuFlags[1] ?
                                'mdi-chevron-up' :
                                'mdi-chevron-down'
                            }}
                          </v-icon>
                        </v-btn>
                        </template>
                        <v-list class="listSheet">
                          <template
                            v-for="(item, index) in statusFilter"
                            >
                            <v-list-item
                              link
                              class="listSheetItem"
                              :key="index +1 * 17 + item.value"
                            >
                              <v-list-item-title class="listSheetTitle"
                              @click="handleStatusFilter(item)">
                                <v-icon size="16" class="iconChips iconChipSize">
                                  {{
                                    item.active ?
                                    'mdi-check-bold' : ''
                                  }}
                                </v-icon>
                                <v-badge
                                  v-if="item.color"
                                  class="d-inline"
                                  inline
                                  :color="item.color ? item.color : ''"
                                  dot
                                ></v-badge>
                                {{ item.label }}
                              </v-list-item-title>
                            </v-list-item>
                            <v-divider
                              v-if="index < typeFilter.length - 1"
                              :key="index * 1390 + item.value"
                            />
                          </template>
                        </v-list>
                      </v-menu>
                    </div>
                  </span>
                  </div>
              </v-slide-item>
            </v-slide-group>

            <div :class="'proactivasS showWeb'"
            v-if="isUserTic && !onlyAccessPulso" :disabled="data.loading">
              <template>
                <spacer></spacer>
                <v-btn
                  icon
                  density="compact"
                  variant="text"
                  class="btn__filter"
                  :ripple="false"
                  to="/pulsodigital/incidenciasproactivas"
                >
                  <span class="proactivasLink" :style="{gap: '1rem'}">
                    <b><u>Incidencias proactivas</u></b>
                    <v-icon
                      :style="{position: 'relative', top: '-2px'}"
                      size="41">
                      icon-ayudadigital-incidencias-relleno
                    </v-icon>
                  </span>
              </v-btn>
              </template>
            </div>
          </v-row>
        </v-col>
      </v-card>
      <!-- FIN LEYENDA -->

      <div id="calendarFixed" :class="{ 'calendarNone': !listFilters[0].active}">
        <template>
          <div>
            <v-sheet
              tile
              height="54"
              class="d-flex"
              justify="center"
            >
              <v-spacer></v-spacer>
              <h3 :style="{color: 'white', margin: '0.4rem'}">{{getMonthSelected()}}</h3>
              <v-spacer></v-spacer>
            </v-sheet>
            <div class="calendar">
              <div class="calendar-buttons" v-if="showArrowLeft">
                <v-btn
                  icon
                  class="ma-2"
                  @click="clickCalendarArrow('left')"
                >
                  <v-badge
                    :value="previousWeekIndicator"
                    dot
                    bordered
                    bottom
                    offset-x="16"
                    offset-y="0"
                    :style="{color: '#27846d'}"
                  >
                    <v-icon :style="{color: '#27846d'}">mdi-chevron-left</v-icon>
                  </v-badge>
                </v-btn>
              </div>
              <v-calendar
                locale="es"
                ref="calendar"
                v-model="selectedDate"
                @click:date="handleDayClick"
                :weekdays="weekday"
                :type="type"
                :events="events"
                :event-overlap-mode="mode"
                :event-color="getEventColor"
              ></v-calendar>
              <div class="calendar-buttons" v-if="showArrowRight">
                <v-btn
                icon
                class="ma-2"
                @click="clickCalendarArrow('right')"
              >
                <v-badge
                  :value="nextWeekIndicator"
                  dot
                  bordered
                  bottom
                  offset-x="18"
                  offset-y="0"
                  :style="{color: '#27846d'}"
                >
                  <v-icon :style="{color: '#27846d'}">mdi-chevron-right</v-icon>
                </v-badge>
              </v-btn>
              </div>
            </div>
          </div>
        </template>
      </div>

      <template v-if="data.loading">
        <v-progress-circular
          class="primary--text"
          :style="{marginTop: '2rem', marginBottom: '2rem', marginLeft: '2rem'}"
          indeterminate
        />
      </template>

      <template v-else>
        <template v-if="selectedNotices.length === 0">
          <p> {{ $t('views.pulsoDigital.empty') }}</p>
        </template>
      </template>
    </div>

    <div ref="scrollContainer">
      <template v-if="typeFilter[0].active">
        <v-card
          color="white"
          :class="{ 'pl-5 pr-5': true}"
        >
          <template v-if="!data.loading" :class="{ 'cardMT':typeFilter[0].active}">
            <SectionObserver
              :items="selectedNotices"
              :selectedDateFromCalendar="selectedDateFromCalendar"
              :stopAutoScroll="stopAutoScroll"
              @clickCalendarArrowFromSection="clickCalendarArrowFromSection"
              @updateStopAutoScroll="updateStopAutoScroll"
            />
          </template>
        </v-card>
      </template>
      <template v-else>
        <PulsoDigitalFilteredList
          :items=filteredNoticesBySearch
          :filters=activeFilters
          :ambitoFilters="ambitoFilters"
          />
      </template>
      <!-- FIN LISTADO-->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { PulsoDigitalFilteredList, SectionObserver } from '@/components';
import SearchField from '../components/form/field-types/Search.vue';

export default {
  components: {
    SearchField,
    PulsoDigitalFilteredList,
    SectionObserver,
  },
  data() {
    return {
      data: {
        loading: false,
        notices: {},
      },
      events: [],
      type: 'week',
      mode: 'stack',
      modes: ['stack', 'column'],
      weekday: [1, 2, 3, 4, 5, 6, 0],
      weekDayES: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
      daysOfTheWeek: [],
      selectedDate: new Date(),
      selectedIndex: null,
      filteredNoticesBySearch: [],
      selectedNotices: [],
      allNotices: [],
      previousWeekIndicator: false,
      nextWeekIndicator: false,
      days: [],
      maxDateList: null,
      minDateList: null,
      showArrowLeft: true,
      showArrowRight: false,
      CISearchList: [],
      properties: {
        alias: 'CISearch',
        label: 'Aplicación',
        config: {
          hint: 'Aplicación',
          component: 'cisearch',
        },
        params: {
          multiple: 'true',
          target: 'backend',
          entity: 'nr',
          fields: 'id,name,zapp_descripcion',
          filters: '{"delete_flag":0, "resource_class":1000118,"status":2606}',
          match: 'name,zapp_descripcion',
          lookandfeel: '#item.name',
          value: 'value',
          alias: 'CISearch',
        },
        specials_values:
        {
          type: 'relation',
        },
        type: {
          name: 'search',
          ZCODE: 'search',
        },
        disableOutlined: true,
        prependIcon: true,
      },
      startY: '',
      isStartScroll: false,
      isStartScrollAndTouched: false,
      isEndScroll: false,
      isEndScrollAndTouched: false,
      listFilters: [
        {
          label: 'Todos',
          active: true,
        },
        {
          label: 'Paradas',
          active: true,
          filter: 'parada',
        },
        {
          label: 'Medio',
          active: true,
          filter: 3,
        },
        {
          label: 'Alto',
          active: true,
          filter: 4,
        },
        {
          label: 'Muy Alto',
          active: true,
          filter: 5,
        },
        {
          label: 'Centralizado',
          active: true,
        },
        {
          label: 'Todos los nodos',
          active: false,
        },
      ],
      typeFilter: [
        {
          label: 'Todos',
          value: 'All',
          active: true,
        },
        {
          label: 'Incidencias',
          value: 'I',
          color: '#FF0022',
          active: false,
        },
        {
          label: 'Paradas',
          value: 'R',
          color: '#DEEBFF',
          active: false,
        },
      ],
      statusFilter: [
        {
          label: 'Abierta',
          value: 'OP',
          color: '#e2e200',
          active: true,
        },
        {
          label: 'Pte. implantar',
          value: 'PL_ENT',
          color: '#e2e200',
          active: true,
        },
        {
          label: 'Planificada',
          value: 'DEL',
          color: '#ed7d31',
          active: true,
        },
        {
          label: 'Pte. confirmar cierre',
          value: 'FIX',
          color: '#ed7d31',
          active: true,
        },
        {
          label: 'Cerrada',
          value: 'CL',
          color: '#808080',
          active: false,
        },
      ],
      ambitoFilter: [
        {
          label: 'Centralizado',
          value: 'central',
          active: true,
          inmutable: true,
        },
        {
          label: '',
          value: 'nodo',
          active: true,
        },
        {
          label: 'Todos los nodos',
          value: 'all',
          active: false,
        },
      ],
      activeFilters: [],
      currentDate: new Date(),
      showMobile: false,
      indexFromFather: new Date(),
      stopAutoScroll: true,
      selectedDateFromCalendar: null,
      isCalendarInput: false,
      locked: false,
      znodoId: null,
      znodoNombre: null,
      menuFlags: [false, false, false],
      onlyAccessPulso: false,
    };
  },
  methods: {
    findTypeName() {
      return this.typeFilter.find((item) => item.active).label;
    },
    findStatusName() {
      return this.statusFilter
        .filter((item) => item.active)
        .map((item) => item.label)
        .join(', ');
    },
    findScopeName() {
      return this.ambitoFilter
        .filter((item) => item.active)
        .map((item) => item.label)
        .join('; ');
    },
    checkIncidencias() {
      if (!this.listFilters[0].active
      && !this.listFilters[1].active
      && (this.listFilters[2].active
      || this.listFilters[3].active
      || this.listFilters[4].active)) {
        return true;
      }
      return false;
    },
    checkParadas() {
      if (this.listFilters[1].active
      && !this.listFilters[2].active
      && !this.listFilters[3].active
      && !this.listFilters[4].active) {
        return true;
      }
      return false;
    },
    showSearch() {
      this.showMobile = !this.showMobile;
    },
    getMonth(notice) {
      const month = this.$getConst('month');
      if (Array.isArray(notice)) {
        const dateAux = new Date(notice[0].date);
        return month[dateAux.getMonth()];
      }
      const dateAux = new Date(notice);
      return month[dateAux.getMonth()];
    },
    spacerMonth(notice) {
      if (Array.isArray(notice)) {
        const dateAux = new Date(notice[0].date);
        return dateAux.getDate().toString() === '1';
      }
      const dateAux = new Date(notice);
      return dateAux.getDate().toString() === '1';
    },
    getDayString(day) {
      const daysWeek = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      if (Array.isArray(day)) {
        const dateArray = new Date(this.parseDate(day[0].date));
        return `${daysWeek[dateArray.getDay()]} ${dateArray.getDate()}`;
      }
      // return `${daysWeek[day.getDay()]} ${day.getDate()}`;
      return `${daysWeek[day.getDay()]} ${day.getDate()}`;
    },
    async getNotices() {
      this.data.loading = true;
      this.isStartScrollAndTouched = true;
      const categoryEnv = process.env.VUE_APP_PULSO_DIGITAL_CATEGORY_PARADA_PLANIFICADA;

      const filters = {
        category: categoryEnv,
        statusParada: ['OP', 'DEL', 'CL'],
        statusIncidencia: ['OP', 'DEL', 'PL_ENT', 'FIX'],
        userNodo: this.znodoId,
      };

      this.data.notices = await this.$api.getClient('solicitudes').getParadas(filters);
      this.filteredNoticesBySearch = this.data.notices;
      this.fillSelectedNotices();
      this.updateCalendarIndicators();
      this.data.loading = false;
    },
    getEventColor(event) {
      return event.color;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    getMonthSelected() {
      const date = new Date(this.selectedDate);
      const monthSelected = date.toLocaleString('es', { month: 'long' });
      return monthSelected.charAt(0).toUpperCase() + monthSelected.slice(1);
    },
    getDaysOfTheWeek() {
      const date = new Date(this.selectedDate);
      const days = [];

      if (date.getDay() === 0) {
        date.setDate(date.getDate() - 1);
      }

      date.setDate(date.getDate() - date.getDay() + 1);
      for (let i = 0; i < 7; i++) { // eslint-disable-line
        days.push(new Date(date.getTime()));
        date.setDate(date.getDate() + 1);
      }
      this.daysOfTheWeek = days;
      this.getDays();
      this.updateCalendarIndicators();
    },
    getDays() {
      const days = [];

      this.daysOfTheWeek.forEach((date) => {
        const day = new Date(date).getDate();

        if (new Date(date).getFullYear() === new Date().getFullYear()
          && new Date(date).getMonth() === new Date().getMonth()
          && new Date(date).getDate() === new Date().getDate()) {
          days.push(`${day} Hoy`);
        } else if (new Date(date).getFullYear() === new Date().getFullYear()
          && new Date(date).getMonth() === new Date().getMonth()
          && new Date(date).getDate() - 1 === new Date().getDate()) {
          days.push(`${day} Mañana`);
        } else {
          days.push(day);
        }
      });

      this.days = days;
    },
    selectIndex(selectedDate) {
      const date = new Date(selectedDate);
      const day = date.getDate();
      const month = date.getMonth();
      const year = date.getFullYear();

      const dateIndex = new Date(year, month, day);
      let findDate = -1;
      this.selectedNotices.forEach((i, index) => {
        const f = new Date(i);
        if (!Array.isArray(i) && this.compareDate(f, dateIndex)) {
          findDate = index;
        } if (Array.isArray(i)) {
          i.forEach((d) => {
            const fechaD = new Date(this.parseDate(d.date));
            if (this.compareDate(fechaD, dateIndex)) {
              findDate = index;
            }
          });
        }
      });
      this.selectedIndex = findDate;
      setTimeout(() => { this.desplazarAElemento(this.selectedIndex); }, 400);
    },
    compareDate(a, b) {
      return (a.getDate() === b.getDate()
            && a.getMonth() === b.getMonth()
            && a.getFullYear() === b.getFullYear());
    },
    desplazarAElemento(elemento) {
      if (elemento) {
        const elem = document.getElementById(`a${elemento}`);
        elem.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    },
    async clickCalendarArrow(click) {
      if (!this.data.loading) {
        this.stopAutoScroll = true;
        this.isCalendarInput = true;
        if (click === 'right') {
          this.$refs.calendar.next();
        }
        if (click === 'left') {
          this.$refs.calendar.prev();
        }
        this.getDaysOfTheWeek();
        this.selectedDate = this.daysOfTheWeek[0]; // eslint-disable-line
        this.fillSelectedNotices();
        setTimeout(() => { this.stopAutoScroll = false; }, 2000);
        if (click === 'right') {
          this.controlArrowsVisibility(this.daysOfTheWeek[0], this.maxDateList, click);
        }
        if (click === 'left') {
          this.controlArrowsVisibility(this.daysOfTheWeek[0], this.minDateList, click);
        }
      }
    },
    clickCalendarArrowFromSection(click, firstDaySection) {
      if (!this.data.loading) {
        if (click === 'right') {
          this.$refs.calendar.next();
          this.controlArrowsVisibility(firstDaySection, this.maxDateList, click);
        }
        if (click === 'left') {
          this.$refs.calendar.prev();
          this.controlArrowsVisibility(firstDaySection, this.minDateList, click);
        }
      }
    },
    controlArrowsVisibility(firstDaySection, controlDate, click) {
      const fistDay = `${firstDaySection.getFullYear()}-${firstDaySection.getMonth() + 1}-${firstDaySection.getDate()}`;
      const fechaControl = new Date(controlDate);
      const fechaFirstDay = new Date(fistDay);

      if ((fechaControl.getTime() >= fechaFirstDay.getTime()) && click === 'left') {
        this.showArrowLeft = false;
        this.showArrowRight = true;
      } else if ((fechaControl.getTime() <= fechaFirstDay.getTime()) && click === 'right') {
        this.showArrowLeft = true;
        this.showArrowRight = false;
      } else {
        this.showArrowLeft = true;
        this.showArrowRight = true;
      }
    },
    fillSelectedNotices() {
      // Lista a sustituir completa
      const noticesListComplete = [];
      // Lista con todas las fechas en formato para sacar min y max
      const datesNoticesAll = [];

      const ambitoFilteredList = this.ambitoFilters(this.filteredNoticesBySearch);
      const statusFilteredList = this.statusFilters(ambitoFilteredList);
      Object.values(statusFilteredList).forEach((elem) => {
        elem.forEach((noti) => {
          const dayNew = this.parseDate(noti.date);
          datesNoticesAll.push(dayNew);
        });
      });

      const max = new Date(Math.max.apply(null, datesNoticesAll));
      const min = new Date(Math.min.apply(null, datesNoticesAll));
      // Comprobaremos si la fecha de hoy es mayor al ultimo registro
      // Si la fecha minima mas 6 dias es mayor a la actual, cogemos de referencia la max + 6 dias,
      // si no, la actual + 6 dias
      const fechaMaxBucle = max.getTime() + (24 * 60 * 60 * 1000 * 6) > this.currentDate.getTime()
        ? max.getTime() + (24 * 60 * 60 * 1000 * 6) + (4 * 60 * 60 * 1000)
        : new Date(this.currentDate.getFullYear(),
          this.currentDate.getMonth(), this.currentDate.getDate()).getTime()
         + (24 * 60 * 60 * 1000 * 6);

      const dateMaxBucle = max.getTime() + (24 * 60 * 60 * 1000 * 6) > this.currentDate.getTime()
        ? max : new Date();
      this.maxDateList = new Date(`${dateMaxBucle.getFullYear()}-${dateMaxBucle.getMonth() + 1}-${dateMaxBucle.getDate()}`);
      const dateMin = new Date(`${min.getFullYear()}-${min.getMonth() + 1}-${min.getDate()}`);
      this.minDateList = dateMin.setDate(dateMin.getDate() - 7);

      // Funciona para crear un registro por cada dia entre el minimo y el maximo disponible
      for (let i = 0;
        fechaMaxBucle - (24 * 60 * 60 * 1000) * i
        >= min.getTime() - (24 * 60 * 60 * 1000 * 10);
        i += 1) {
        /*
        Bucle: fecha maxima - 1 dia*i, hasta que sea igual a la minima
        */
        const fechaBucle = fechaMaxBucle - (24 * 60 * 60 * 1000) * i;
        const noticeDay = [];
        /*
        Buscaremos en las noticias una conincidencia
        */
        Object.values(statusFilteredList).forEach((elem) => {
          elem.forEach((noti) => {
            const fechaNoticia = this.parseDate(noti.date);

            if (this.compareDate(new Date(fechaNoticia), new Date(fechaBucle))) {
              let checkNoti = false;
              datesNoticesAll.forEach((dn) => {
                if (this.compareDate(new Date(dn), new Date(fechaNoticia))) {
                  checkNoti = true;
                }
              });
              if (checkNoti) { noticeDay.push(noti); }
            }
          });
        });
        if (noticeDay.length > 0) {
          noticesListComplete.push(noticeDay);
        } else {
          noticesListComplete.push(new Date(fechaBucle));
        }
      }

      this.selectedNotices = noticesListComplete.reverse();
    },
    parseDate(date) {
      const fecha = date.split('/');
      const day = fecha[0];
      const month = fecha[1];
      const year = fecha[2];
      return new Date(`${month}/${day}/${year.substring(2, 4)}`);
    },
    updateCalendarIndicators() {
      const keys = Object.keys(this.filteredNoticesBySearch);
      const previous = keys.find((item) => {
        const itemSplitted = item.split('/');
        const newDate = `${itemSplitted[1]}/${itemSplitted[0]}/${itemSplitted[2]}`;

        const monday = `${this.daysOfTheWeek[0].getMonth() + 1}/${this.daysOfTheWeek[0].getDate()}/${this.daysOfTheWeek[0].getFullYear()}`;
        return new Date(newDate) < new Date(monday);
      });
      this.previousWeekIndicator = !!previous;

      const next = keys.find((item) => {
        const itemSplitted = item.split('/');
        const newDate = `${itemSplitted[1]}/${itemSplitted[0]}/${itemSplitted[2]}`;

        const sunday = `${this.daysOfTheWeek[6].getMonth() + 1}/${this.daysOfTheWeek[6].getDate()}/${this.daysOfTheWeek[6].getFullYear()}`;
        return new Date(newDate) > new Date(sunday);
      });

      this.nextWeekIndicator = !!next;
    },
    onchangeCISearchList(value) {
      const lista = [];

      if (value && value.length > 0) {
        value.map((item) => lista.push(item));
      }
      this.CISearchList = lista;
      this.filterNoticesBySearch();
      this.fillSelectedNotices();
      this.updateCalendarIndicators();
    },
    filterNoticesBySearch() {
      const allNotices = this.data.notices;
      const searchList = this.CISearchList;
      const category = process.env.VUE_APP_PULSO_DIGITAL_CATEGORY_PARADA_PLANIFICADA;

      if (searchList && searchList.length > 0) {
        const keys = Object.keys(allNotices);
        const newNoticesList = {};
        keys.forEach((key) => {
          allNotices[key].forEach((notice) => {
            let isIncluded = false;
            if (notice.category === category && notice.affectedCI) { // es parada
              const CIList = notice.affectedCI.split(', ');
              isIncluded = CIList.find((item) => searchList.includes(item));
            } else if (searchList.includes(notice.affectedCI)) { // es incidencia
              isIncluded = true;
            }

            if (isIncluded) {
              if (!newNoticesList[key]) {
                newNoticesList[key] = [notice];
              } else {
                newNoticesList[key].push(notice);
              }
            }
          });
        });
        this.filteredNoticesBySearch = newNoticesList;
      } else {
        this.filteredNoticesBySearch = allNotices;
      }

      this.fillSelectedNotices();
    },
    /* eslint-disable no-param-reassign */
    clickChip(item) {
      if (item.label === 'Todos') {
        this.listFilters.slice(0, 5).forEach((filter) => {
          if (filter.label !== item.label) {
            filter.active = false;
          } else {
            filter.active = true;
          }
          this.selectedDate = new Date();
          this.selectIndex(new Date());
        });
      } else if (item === 'Incidencias') {
        this.listFilters[0].active = false;
        this.listFilters[1].active = false;
        this.listFilters[2].active = true;
        this.listFilters[3].active = true;
        this.listFilters[4].active = true;
      } else if (item.label === 'Paradas') {
        this.listFilters[0].active = false;
        this.listFilters[1].active = true;
        this.listFilters[2].active = false;
        this.listFilters[3].active = false;
        this.listFilters[4].active = false;
      } else if (item === 'IncidenciasAll') {
        this.listFilters[0].active = false;
        this.listFilters[1].active = false;
        this.listFilters[2].active = true;
        this.listFilters[3].active = true;
        this.listFilters[4].active = true;
      } else if (item === 'Muy Alto') {
        this.listFilters[0].active = false;
        this.listFilters[1].active = false;
        this.listFilters[2].active = false;
        this.listFilters[3].active = false;
        this.listFilters[4].active = true;
      } else if (item === 'Alto') {
        this.listFilters[0].active = false;
        this.listFilters[1].active = false;
        this.listFilters[2].active = false;
        this.listFilters[3].active = true;
        this.listFilters[4].active = false;
      } else if (item === 'Medio') {
        this.listFilters[0].active = false;
        this.listFilters[1].active = false;
        this.listFilters[2].active = true;
        this.listFilters[3].active = false;
        this.listFilters[4].active = false;
      } else if (item.label === 'Todos los nodos') {
        this.listFilters[6].active = true;
        this.listFilters[7].active = false;
        this.fillSelectedNotices();
      } else {
        this.listFilters[6].active = false;
        this.listFilters[7].active = true;
        this.fillSelectedNotices();
      }

      // else {
      //   this.listFilters[0].active = false;
      //   this.listFilters.forEach((filter) => {
      //     if (filter.label === item.label) {
      //       filter.active = !filter.active;
      //     }
      //   });

      //   const allFiltersInactive = this.listFilters.every((filter) => !filter.active);

      //   if (allFiltersInactive) {
      //     this.listFilters[0].active = true;
      //   }
      //   console.log('clickchip2', { allFiltersInactive, filt: this.listFilters });
      // }
      // this.getActiveFilters();
    },
    handleTypeFilter(item) {
      this.typeFilter.forEach((elem) => {
        if (item.value === elem.value) {
          elem.active = true;
        } else {
          elem.active = false;
        }
      });
      this.getActiveFilters();
    },
    handleStatusFilter(item) {
      this.statusFilter.forEach((elem) => {
        if (item.value === elem.value) {
          elem.active = !elem.active;
        }
      });
      this.getActiveFilters();
      this.fillSelectedNotices();
    },
    handleAmbitoFilter(item) {
      this.ambitoFilter.forEach((elem) => {
        if (item.value === elem.value || elem.value === 'central') {
          elem.active = true;
        } else {
          elem.active = false;
        }
      });
      this.getActiveFilters();
      this.fillSelectedNotices();
    },
    getActiveFilters() {
      const typeFilter = this.typeFilter.filter((item) => item.active);
      const statusFilter = this.statusFilter.filter((item) => item.active);
      const ambitoFilter = this.ambitoFilter.filter((item) => item.active);

      this.activeFilters = {
        type: typeFilter,
        status: statusFilter,
        ambito: ambitoFilter,
      };
    },
    ambitoFilters(notices) {
      // Se muestran todos los registros si el filtro de 'Todos los nodos' está activo
      if (this.ambitoFilter[2].active) {
        return notices;
      }

      // En caso de no estarlo, se recogen solo los
      // registros centralizados y con mismo nodo que el usuario
      const ambitoFilteredList = {};
      Object.keys(notices).forEach((key) => {
        notices[key].forEach((notice) => {
          let isNodoUser = false;
          if (Array.isArray(notice.nodoId)) {
            isNodoUser = notice.nodoId.includes(this.znodoId);
          } else {
            isNodoUser = notice.nodoId === this.znodoId;
          }

          if (notice.centralizada === 1 || isNodoUser) {
            if (!ambitoFilteredList[key]) {
              ambitoFilteredList[key] = [notice];
            } else {
              ambitoFilteredList[key].push(notice);
            }
          }
        });
      });
      return ambitoFilteredList;
    },
    statusFilters(notices) {
      const res = {};

      Object.keys(notices).forEach((key) => {
        notices[key].forEach((notice) => {
          const matchStatus = this.activeFilters.status.some((estado) => estado.value === notice.status); // eslint-disable-line
          if (matchStatus) {
            if (!res[key]) {
              res[key] = [notice];
            } else {
              res[key].push(notice);
            }
          }
        });
      });

      return res;
    },
    updateStopAutoScroll(newVal) {
      this.stopAutoScroll = newVal;
    },
    handleDayClick(day) {
      this.selectIndex(day.date);
    },
    navigateToMap() {
      this.$router.push({
        name: 'PulsoDigitalMap',
        params: {
          idNodo: this.listFilters[6].active ? null : `${this.znodoId}`,
        },
      });
    },
    isCitizen() {
      return this.user.hasIosUser();
    },
  },
  watch: {
    selectedDate(newVal) {
      this.selectedDateFromCalendar = new Date(newVal);
      if (this.isCalendarInput) {
        this.selectIndex(newVal);
        this.isCalendarInput = false;
      }
    },
    arrayFilters: {
      handler() {
        this.getActiveFilters();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      get: 'globalState/get',
    }),
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
    isMobile() {
      const getter = this.$store.getters['globalState/get'];
      return getter('deviceOS') != null;
    },
    isUserTic() {
      const user = this.$store.getters['session/user'];
      return user.accessTypeTic;
    },
    arrayFilters() {
      return [this.typeFilter, this.statusFilter, this.ambitoFilter];
    },
  },
  async created() {
    if (this.isCitizen()) {
      this.$store.dispatch('messages/createNotificationMessage', {
        title: 'No tienes acceso para visualizar este módulo',
        type: 'error',
        timeout: this.$getConst('notifications.timeoutPlus'),
        dismissible: true,
      });

      this.$router.push('/');
    } else {
      this.locked = this.get('blockNavigator') || false;
      this.userClient = this.$api.getClient('user');
      const session = this.$store.getters['session/user'];
      this.znodoId = session.znodoId;
      this.znodoNombre = session.znodoNombre.slice(0, 1)
      + session.znodoNombre.slice(1, session.znodoNombre.length).toLowerCase();
      this.listFilters.push({ label: this.znodoNombre, active: true });
      this.ambitoFilter[1].label = this.znodoNombre;
      this.ambitoFilter[1].value = this.znodoId;
      window.addEventListener('eventoLockWindow', () => {
        this.locked = this.get('blockNavigator') || false;
      });

      this.$root.$on('CISearch', (data) => {
        this.onchangeCISearchList(data.value);
      });
      this.getDaysOfTheWeek();
      await this.getNotices();
      if (this.isMobile) {
        this.updateStopAutoScroll(true);
        setTimeout(() => { this.selectIndex(new Date()); }, 3000);

        setTimeout(() => { this.selectedDate = new Date(); }, 4500);

        setTimeout(() => { this.updateStopAutoScroll(false); }, 5000);
      } else {
        this.selectIndex(new Date());
      }
    }
  },
  mounted() {
    this.onlyAccessPulso = localStorage.getItem('onlyAccessPulso');
  },
};
</script>

<style scoped>
  .scroll__start {
    height: 1px;
  }
  .container__notice .v-card__text.py-2 {
    background-color: white !important;
  }
  ::v-deep .v-calendar-daily__intervals-head{
    display: none !important;
  }
  ::v-deep .v-calendar-daily__day-interval {
    display: none !important;
  }
  ::v-deep .v-calendar-daily__interval-text {
    display: none;
  }
  ::v-deep .v-calendar-daily__intervals-body {
    display: none !important
  }
  ::v-deep .v-calendar-daily__scroll-area {
    display: none !important;
  }
  ::v-deep .v-calendar-daily__day .v-future {
    display: none !important;
  }
  ::v-deep .v-calendar-daily_head-day .v-future {
    display: none !important;
  }

  ::v-deep .v-calendar-daily_head-day.v-future {
    border-right: 1px solid rgb(244, 244, 244, 0.5) !important;
    border-bottom: 1px solid rgb(244, 244, 244, 0.5) !important;
  }

  ::v-deep .v-calendar-daily_head-day.v-present {
    border-right: 1px solid rgb(244, 244, 244, 0.5) !important;
    border-bottom: 1px solid rgb(244, 244, 244, 0.5) !important;
  }

  ::v-deep .v-calendar-daily_head-day.v-past {
    border-right: 1px solid rgb(244, 244, 244, 0.5) !important;
    border-bottom: 1px solid rgb(244, 244, 244, 0.5) !important;
  }

  ::v-deep .v-calendar-daily{
    border: none !important;
  }

  ::v-deep .v-calendar-daily__body {
    display: none !important;
  }
  ::v-deep .v-sheet{
    height: fit-content !important;
    background: #27846d;
    border-radius: 5px !important;
  }
  ::v-deep .v-calendar{
    border-radius: 5px !important;
    width: 100% !important;
  }
  .indexed {
    color: #27846d;
  }
  .emptyDay {
    margin-left: 1.3rem;
  }
  .calendar {
    display: flex;
  }
  .calendar-buttons {
    background: rgb(255, 255, 255);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    border: 1px solid rgb(224, 224, 224, 0.5);
    width: 5%;
  }
  ::v-deep .v-btn:before {
    background-color: #27846d !important;
  }

  .searchbox_style {
    background: white;
  }
  .titleAndMap{
    display:flex
  }
  .titleH2{
    width: calc(100% - 50px) !important;
  }

  ::v-deep .v-slide-group__next,
  ::v-deep .v-slide-group__prev {
    min-width: initial !important;
    flex: 0 1 30px !important;
  }
  .chip__filter{
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    padding-left: 8px !important;
    padding-right: 0px !important;
  }
  .chipMenu{
    display: flex;
    align-items: center;
  }
  .btnSize{
    height: 20px !important;
    width: 20px !important;
  }
  .btn__filter {
    height: 20px !important;
    width: 100% !important;
    text-transform: initial;
    color: initial !important;
    letter-spacing: initial !important;
  }
  .btn__filter,
  .btn__filter:focus,
  .btn__filter:active,
  .btn__filter::before {
    background-color: transparent !important;
  }

  /* Para pantallas de 1263px en adelante */
  @media screen and (min-width: 1264px) {
    .calendarFixed {
      width: calc(100% - 154px) !important;
      padding-left: 12px !important;
      padding-right: 12px !important;
    }

    .calendarFixedLocked {
      width: calc(100% - 390px) !important;
      padding-left: 12px !important;
      padding-right: 12px !important;
    }
  }

  /* Para pantallas entre 951px y 1262px */
  @media screen and (min-width: 901px) and (max-width: 1263px) {
    .calendarFixed {
      width: calc(100% - 40px) !important;
      padding-left: 12px !important;
      padding-right: 12px !important;
    }

    .calendarFixedLocked {
      width: calc(100% - 40px) !important;
      padding-left: 12px !important;
      padding-right: 12px !important;
    }
  }

  /* Para pantallas de 950px o menos */
  @media screen and (max-width: 959px) {
    .calendarFixed {
      width: calc(100% - 34px) !important;
      padding-left: 12px !important;
      padding-right: 12px !important;
    }

    .calendarFixedLocked {
      width: calc(100% - 34px) !important;
      padding-left: 12px !important;
      padding-right: 12px !important;
    }
  }

  /* Para pantallas de 950px o menos */
  @media screen and (max-width: 440px) {
    .showWeb{
      display: none
    }
    .showMobile{
      display: flex !important;
    }
    .searchMobile{
      margin-top: 0.5rem;
    }
    .searchMobileHide{
      display: none !important;
      margin-top: 0.5rem;
    }
  }

  /* @media screen and (min-width: 440px) {
    .showMobile{
      display: none !important;
    }
  } */

  @media screen and (max-width: 375px) {
    .leyenda {
      gap: 0.3rem !important;
    }
  }

  @media screen and (max-width: 358px) {
    .leyendIcon {
      font-size: 20px;
    }
    .leyendParagraph {
      font-size: 14px;
    }
    .showSearchBtn {
      width: 30px;
      height: 30px;
    }
  }

  .calendarNone{
    display: none
  }

  .calendarFixed {
    position: fixed;
    z-index: 1;
    top:3.8rem;
    padding-top: 1rem;
    background-color: white;
    display: block;
    width: 100%;
    padding-left: 12px;
    padding-right: 12px;
    }

    .calendarFixedLocked {
    position: fixed;
    z-index: 1;
    top:3.8rem;
    padding-top: 1rem;
    background-color: white;
    display: block;
    width: 100%;
    padding-left: 12px;
    padding-right: 12px;
    }

  #no-background-hover::before {
    background-color: transparent !important;
  }

  .filtersChips{
    margin: 0.25rem !important;
  }

  .icon-ayudadigital-incidencia:before {
    color: black !important;
  }

  .icon-ayudadigital-parada:before {
    color: black !important;
  }

  .leyenda_box {
    box-shadow: none !important;
  }
  .list_box {
    box-shadow:
      0px 2px 2px 0px rgba(0, 0, 0, 0.14),
      0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
  }

  .leyendParagraph {
    margin: 0;
  }

  .icon-ayudadigital-calendario:before {
    color: #000;
  }

  .v-chip:hover {
    cursor: pointer;
  }
  .chip__active {
    border: 2px solid #27846d !important;
  }
  .cardMT{
    margin-top: 74rem;
  }
  .middle-hr {
    border-color: inherit;
    border-width: 2px 0;
    border-style: solid;
    display: flex;
    justify-content: center;
    color:rgb(39, 132, 109);
    padding-bottom: 0.3rem;
    padding-top: 0.3rem;
    font-size: 17px;
  }
  .activeBtnSearchMobile{
    border-radius: 40px !important;
  }

  .month_container {
    margin: 1.5rem 0 !important;
  }
  .container__chip {
    margin-left: 0rem;
    padding: 0px !important;
  }
  .iconChips{
  color:#27846d !important;
  }
  .iconChipSize{
    min-width: 16px !important;
    max-width: 16px !important;
  }
  .filterSheet{
    background: white;
    display:flex;
    overflow: hidden;
  }
  .listSheet{
    background: white;
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
      0px 8px 10px 1px rgba(0, 0, 0, 0.14),
      0px 3px 14px 2px rgba(0, 0, 0, 0.12) !important;
    display: grid;
    border: 1px green solid;
    border-radius: 0.4rem;
    padding: 0px !important;
  }
  .listSheetItem{
    display: block;
    min-height: 1rem;
    padding: 0.25rem
    /* padding-top: 0.25rem;
    padding-bottom: 0.25rem; */
  }
  .v-menu__content{
    margin-top:2.5rem;
    box-shadow: none !important;
  }

  .myRequestScroll{
    overflow: hidden;
    white-space: nowrap;
    overflow-x: auto;
    padding-bottom: 4px;
  }
  .proactivasLink{
    color: #27846d;
    display: flex;
    gap: 0.5rem;
  }
  .proactivasS{
    margin-left: auto;
    margin-right: 0.5rem;
  }

  .myRequestScroll::-webkit-scrollbar {
    display: none;
  }
  @media screen and (max-width: 600px) {
    .myRequestScroll{
      overflow: hidden;
      white-space: nowrap;
      overflow-x: auto;
      padding-bottom: 4px;
    }
  }
  .proactivasS{
    display: flex;
    align-items: center;
  }
</style>
